export default function getCards(state) {
  return state.games.whoisit.cards;
}
